module.exports = __webpack_public_path__ + "media/background.54314d2c.mp4";